<!-- dashboard.component.html -->
<app-navbar [navList]="navList" [filters]="contextListFilter()" filterButtonPlaceholder="Contesti"
  (filterEvent)="onSelectedContextsChange($event)" [helperQuotaRequest]="hasAdmPermission()" />

<div class="qai-content-box overflow-auto py-4">

  @if(quotaSrv.alertLvl === 'danger' || quotaSrv.alertLvl === 'warning') {
  <div class="alert d-flex align-items-center" [class]="'alert-' + quotaSrv.alertLvl" role="alert">
    <div>
      <fa-icon class="px-4" [icon]="faWarning"></fa-icon>
      <span i18n>
        {{ quotaSrv.alertLvl == 'danger' ? 'Attenzione soglie di utilizzo in situazione critica ' : 'Avviso, stai raggiungendo le soglie di utilizzo ' }}
      </span>
    </div>
  </div>
  }

  <app-storage-usage [segments]="dataSpace" [totalAvailable]="totalAvailableSpace" [loading]="quotaSrv.contextListQuotasLoading()"></app-storage-usage>

  <div class="card qai-card p-3 shadow-sm bg-light">

    <div class="mb-3">
      <app-datepicker-range-popup [minDate]="licenseStartDate"
        (dateRangeChange)="onDateRangeChange($event)"></app-datepicker-range-popup>
    </div>

    <div class="row mb-3">

      <div class="col-md-4">
        <app-query-counter [totalRequests]="totalRequests" [totalAvailableRequests]="totalAvailableRequests"
          [showQuota]="isCurrentInvoicePeriod" [loading]="segmentDataLoading()"></app-query-counter>
      </div>

      <div class="col-md-8">
        <div class="card qai-card p-3 shadow-sm">
          <div class="card-header bg-white border-0 pb-0">
            <h5>Distribuzione Query</h5>
          </div>
          <div class="card-body p-0">
            <app-donut-chart [segments]="dataQueryDonutChart"></app-donut-chart>
          </div>
        </div>
      </div>

    </div>

    <div class="card qai-card p-3 shadow-sm">

      <div class="card-header bg-white border-0">
        <ul class="nav nav-tabs">
          <li class="nav-item" style="border-right: 2px solid lightgray;">
            <a class="nav-link" [class.active]="selectedAreaChart() === 'queries'" (click)="selectChart('queries')"
              href="javascript:void(0)">
              Andamento numero query
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="selectedAreaChart() === 'space'" (click)="selectChart('space')"
              href="javascript:void(0)">
              Spazio occupato in MB
            </a>
          </li>
        </ul>
      </div>

      <div class="card-body">
        <app-area-chart [segments]="selectedChartData" [onlyIntegers]="selectedAreaChart() === 'queries' ? true : false"
          [label]="selectedAreaChart() === 'queries' ? 'Query' : 'Spazio in MB'"></app-area-chart>
      </div>
    </div>

    <div class="row align-items-center mt-3">
      <div class="col-auto pe-0">
        <button class="btn btn-primary" (click)="downloadReport('csv')">
          <fa-icon [icon]="faFileCsv"></fa-icon>
          Scarica Dettagli in CSV
        </button>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary" (click)="downloadReport('excel')">
          <fa-icon [icon]="faFileExcel"></fa-icon>
          Scarica Dettagli in XLSX
        </button>
      </div>
      @if (lastUpdateDate) {
      <div class="col ms-auto text-end">
        <p class="mb-0">
          Dati aggiornati al: {{ lastUpdateDate | date: 'dd/MM/yyyy HH:mm' }}.
        </p>
      </div>
      }
    </div>

  </div>

</div>